import { ref } from 'vue'
import { SesionService, type CanalJustificante } from '@/services/SesionService'

export const isReciboModalOpen = ref(false)
export const reciboModalPuedeCerrar = ref(true)
export const reciboModalResuelto = ref(false)
export const reciboModalCartId = ref<number | null>(null)
export const reciboModalImporte = ref<number | string>('')
export const reciboModalTexto = ref('')
export const reciboModalPideConfirmacion = ref(false)
export const reciboModalEnviando = ref(false)
export const reciboModalPaso = ref<'pregunta' | 'otro-canal' | 'cambiar-destino' | 'incidencia'>('pregunta')
export const reciboCanalesUsados = ref<CanalJustificante[]>([])
export const reciboPuedeEmail = ref(false)
export const reciboPuedeSms = ref(false)
export const reciboEmailFicha = ref('')
export const reciboTelefonoOfuscado = ref('')
export const reciboModalEmailNuevo = ref('')
export const reciboModalTelefonoNuevo = ref('')

const salidaBloqueada = ref(false)
const asistenciaIdBloqueada = ref<string | number | null>(null)
let pendienteAbandonoEnviado = false

export function reciboSalidaBloqueada(): boolean {
    return salidaBloqueada.value && !reciboModalResuelto.value
}

export function esRutaPagoReciboPermitida(fullPath: string): boolean {
    const id = asistenciaIdBloqueada.value
    if (id == null) {
        return true
    }
    return fullPath.includes('/payment/' + id)
}

export function rutaPagoReciboBloqueada(): string {
    return '/payment/' + (asistenciaIdBloqueada.value ?? '')
}

const onPageHide = () => {
    if (!reciboSalidaBloqueada() || pendienteAbandonoEnviado) {
        return
    }
    const cartId = reciboModalCartId.value
    if (typeof cartId !== 'number') {
        return
    }
    pendienteAbandonoEnviado = true
    SesionService.marcarJustificantePendiente(cartId)
}

const onEscape = (event: KeyboardEvent) => {
    if (event.key !== 'Escape' || !reciboSalidaBloqueada()) {
        return
    }
    event.preventDefault()
    event.stopImmediatePropagation()
}

if (typeof window !== 'undefined') {
    window.addEventListener('pagehide', onPageHide)
    window.addEventListener('beforeunload', onPageHide)
    window.addEventListener('keydown', onEscape, true)
}

export function bloquearSalidaRecibo(asistenciaId: string | number): void {
    asistenciaIdBloqueada.value = asistenciaId
    pendienteAbandonoEnviado = false
    salidaBloqueada.value = true
    reciboModalResuelto.value = false
    reciboModalPuedeCerrar.value = false
}

export function desbloquearSalidaRecibo(): void {
    salidaBloqueada.value = false
    asistenciaIdBloqueada.value = null
}

export function useReciboSalidaLock() {
    return {
        isReciboModalOpen,
        reciboModalPuedeCerrar,
        reciboModalResuelto,
        reciboModalCartId,
        reciboModalImporte,
        reciboModalTexto,
        reciboModalPideConfirmacion,
        reciboModalEnviando,
        reciboModalPaso,
        reciboCanalesUsados,
        reciboPuedeEmail,
        reciboPuedeSms,
        reciboEmailFicha,
        reciboTelefonoOfuscado,
        reciboModalEmailNuevo,
        reciboModalTelefonoNuevo,
        bloquearSalidaRecibo,
        desbloquearSalidaRecibo,
        reciboSalidaBloqueada,
    }
}
